import React, { useEffect } from "react";
import {
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModalOptionCard,
    StandardModalOptionCardText,
    StandardModalOptionCardTitle,
    StandardModalOptionsGrid,
    StandardModalSection
} from "src/components";
import pluralize from "pluralize";

const AddNewUserOptionsModal = (props) => {
    const { showDialog, handleClose, openUserDetailsForm, openUploadUserListModal, isSubscriptionCapReached, showSubscriptionCapReachedModal, customNames } = props;

    useEffect(() => {
        if (isSubscriptionCapReached) {
            handleClose();
            showSubscriptionCapReachedModal();
        }
    }, []);
    
    return (
        <StandardModal
            open={showDialog}
            onClose={handleClose}
            widthMode="large"
            title="Add New Users"
            description={`Here, you have the flexibility to either manually add users one by one – be it ${pluralize.singular(customNames.employees)} or ${pluralize.singular(customNames.clients)}. Alternatively, if you have a large number of users to integrate, save time by utilising our CSV template, specifically designed to make bulk uploads seamless and efficient.`}
            footer={(
                <StandardModalActionGroup $pushRight>
                    <StandardModalActionButton
                        width="140px"
                        onClick={handleClose}
                        className="form-btns disabled"
                    >
                        Cancel
                    </StandardModalActionButton>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection>
                <StandardModalOptionsGrid>
                    <StandardModalOptionCard>
                        <StandardModalOptionCardText>
                            <StandardModalOptionCardTitle>Add Single User</StandardModalOptionCardTitle>

                            <StandardModalDescription>
                                Opt to add a single user, whether an{" "}
                                {pluralize.singular(customNames.employees)} or{" "}
                                {pluralize.singular(customNames.clients)}.
                            </StandardModalDescription>
                        </StandardModalOptionCardText>

                        <StandardModalActionButton
                            $variant="primary"
                            width="140px"
                            onClick={() => {
                                handleClose();
                                openUserDetailsForm();
                            }}
                        >Add User
                        </StandardModalActionButton>
                    </StandardModalOptionCard>

                    <StandardModalOptionCard>
                        <StandardModalOptionCardText>
                            <StandardModalOptionCardTitle>Upload User List</StandardModalOptionCardTitle>

                            <StandardModalDescription>
                                Choose to upload an entire list of{" "}
                                {pluralize(customNames.employees)} or{" "}
                                {pluralize(customNames.clients)} with our efficient CSV file
                                integration.
                            </StandardModalDescription>
                        </StandardModalOptionCardText>

                        <StandardModalActionButton
                            $variant="primary"
                            width="180px"
                            onClick={() => {
                                handleClose();
                                openUploadUserListModal();
                            }}
                        > Upload CSV User List
                        </StandardModalActionButton>
                    </StandardModalOptionCard>
                </StandardModalOptionsGrid>
            </StandardModalSection>
        </StandardModal>
    );
};

export default AddNewUserOptionsModal;
